import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../settings/settings.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { Router, RouterModule } from '@angular/router';
import { ConfirmDialog } from '../dialog.component';


declare var $ :any;


@Component({
  selector: 'app-menu-simpli',
  standalone: true,
  imports:[CommonModule, MaterialModule, RouterModule],
  templateUrl: './menu-simpli.html',
  styleUrls: ['./menu-simpli.less']
})


export class MenuSimpli implements OnInit {
   

  @Input() menu_cliente:boolean=true;
  @Input() menu_confirming_pronto_pago:boolean=false;
  @Input() id_company:any;

  selectedOption: string = '';

  constructor(public snackBar: MatSnackBar, 
    public dialog: MatDialog,  
    public settings: SettingsService, 
    private changeDetect:ChangeDetectorRef, 
    public router:Router){


  }

  is_responsive:boolean=false;
  ngOnInit() {

    if (window.screen.width <= 1024) {
      this.is_responsive = true;
    }else{
      this.is_responsive = false;
    }

    setTimeout(() => {
      $('.sub-menu ul').hide();
      $(".sub-menu a").click(function(this:any){
        $(this).parent(".sub-menu").children("ul").slideToggle("100");
        $(this).find(".right").toggleClass("fa-caret-up fa-caret-down");
      });
    });

    this.changeDetect.detectChanges()


  }

  menu(){

    $(this).parent(".sub-menu").children("ul").slideToggle("100");
    $(this).find(".right").toggleClass("fa-caret-up fa-caret-down");

  }

  menu_desplegado:boolean=false;
  mouseenter($event:any){
    if(this.menu_desplegado == false){
      //mostrar
      $("#menupagoproveedores").parent(".sub-menu").children("ul").slideToggle("100");
      $("#menupagoproveedores").find(".right").toggleClass("fa-caret-up fa-caret-down");
      this.menu_desplegado = true;
    }else if(this.menu_desplegado == true){
      //ocultar
      $("#menupagoproveedores").parent(".sub-menu").children("ul").slideToggle("100");
      $("#menupagoproveedores").find(".right").toggleClass("fa-caret-up fa-caret-down");
      this.menu_desplegado = false
    }

  }

  go_to_resumen(){
    setTimeout(() => {
      $("#caja_linea").trigger('click');
    });
  }

  logout() {
    let dialogRef = this.dialog.open(ConfirmDialog, {
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      this.selectedOption = result;

      if (this.selectedOption == 'Y') {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('user_id');
        this.router.navigateByUrl('/login');
      }
    });
  }

}


